export class FormWrapper extends HTMLElement {
	static NAME = "form-wrapper";

	get form() {
		return this.querySelector("form");
	}

	connectedCallback() {
		if (!this.form) {
			return;
		}

		this.scrollIfSubmitted();
	}

	// disconnectedCallback() {
	// }

	scrollIfSubmitted() {
		if (this.wasSubmitted()) {
			this.scrollIntoView({ block: "center" });
		}
	}

	wasSubmitted() {
		const data = new FormData(this.form);
		const notFirstStep = Number(data.get("FormStep")) > 0;
		const previousClicked = data.get("PreviousClicked") === "clicked";

		return notFirstStep || previousClicked;
	}
}

customElements.define(FormWrapper.NAME, FormWrapper);
